module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2fm"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_vm._v("Acknowledgments")])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The vision of this book started many years ago with a group of men and women in Northern California who sat in a drunk-driving treatment program as program failures. They had tried everything, felt terrible, and were willing to think about healing in a new way. Their quest for recovery moved me to my own. The shared journey started the reality of what has happened in the more than twenty years since "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Potatoes Not Prozac")]), _vm._v(" was first published.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the first edition was published, I set out to develop an online healing community to allow people from all over the world to share with one another. Ten years later, I had read more than half a million letters and emails from all over the world. Now, twenty years later, that number is closer to a million as the power of the original steps continues to change people’s lives. Many of the people who started their programs back then are still around, still showing up and helping new people.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even more important, the healing continues. Carolyn Reidy at Simon & Schuster got the vision at its inception, and her willingness to grow with it gifts all of us. My new editor, Emily Graff, wrapped her heart around the unfolding of this new edition, a testament to where Step 7 goes for all of us who believe that food is a healer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A golden retriever in training still lies at my feet in the morning as your voices are woven into written words. The dialogue continues and the wisdom has grown. My gratitude is deep and wide.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1259d92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ack.vue
// module id = 75
// module chunks = 0